import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { AuthContext } from "../context/authContext";
import DeleteImage from "../images/delete.png";

const SinglePicture = () => {
  const [picture, setPicture] = useState({});
  const [comments, setComments] = useState([]);
  const [commentText, setCommentText] = useState("");
  const [likeCount, setLikeCount] = useState(0);
  const [likedByUser, setLikedByUser] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const picId = location.pathname.split("/")[2];

  const { currentUser } = useContext(AuthContext);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`/api/pictures/${picId}`);
        setPicture(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, [picId]);

  useEffect(() => {
    const fetchComments = async () => {
      try {
        const res = await axios.get(`/api/comments/${picId}?type=picture`);
        setComments(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchComments();
  }, [picId]);

  useEffect(() => {
    const fetchLikes = async () => {
      try {
        const res = await axios.get(`/api/likes/${picId}?type=picture`);
        setLikeCount(res.data.count);
        setLikedByUser(res.data.likedByUser);
      } catch (err) {
        console.log(err);
      }
    };
    fetchLikes();
  }, [picId]);

  const handleDelete = async () => {
    try {
      await axios.delete(`/api/pictures/${picId}`);
      navigate("/pictures");
    } catch (err) {
      console.log(err);
    }
  };

  const handleLike = async () => {
    if (!currentUser) {
      navigate("/login");
      return;
    }
    try {
      await axios.post("/api/likes", { postId: picId, type: "picture" });
      setLikedByUser(!likedByUser);
      setLikeCount(likedByUser ? likeCount - 1 : likeCount + 1);
    } catch (err) {
      console.log(err);
    }
  };

  const handleCommentSubmit = async (e) => {
    e.preventDefault();
    if (!currentUser) {
      navigate("/login");
      return;
    }
    if (!commentText.trim()) return;

    try {
      await axios.post("/api/comments", {
        postId: picId,
        text: commentText,
        type: "picture",
      });
      setCommentText("");
      const res = await axios.get(`/api/comments/${picId}?type=picture`);
      setComments(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="single">
      <div className="content">
        <img src={`/upload/${picture?.img}`} alt="post cover" />

        <div className="user">
          <div className="info">
            <span>{picture.username}</span>
            <p>Posted {moment(picture.date).fromNow()}</p>
          </div>
          {currentUser?.username === picture.username && (
            <div className="edit">
              <img onClick={handleDelete} src={DeleteImage} alt="delete" />
            </div>
          )}
        </div>

        {picture.caption && <p>{picture.caption}</p>}

        <div className="likes">
          <button onClick={handleLike} className={likedByUser ? "liked" : ""}>
            {likedByUser ? "★ Liked!" : "☆ Like"}
          </button>
          <span>{likeCount} {likeCount === 1 ? "like" : "likes"}</span>
        </div>

        <div className="comments">
          <h2>Comments ({comments.length})</h2>

          {currentUser ? (
            <form onSubmit={handleCommentSubmit} className="comment-form">
              <textarea
                placeholder="Say something nice..."
                value={commentText}
                onChange={(e) => setCommentText(e.target.value)}
              />
              <button type="submit">Post comment</button>
            </form>
          ) : (
            <p className="login-prompt">
              <Link to="/login">Log in</Link> to like or comment!
            </p>
          )}

          <div className="comment-list">
            {comments.map((c) => (
              <div className="comment" key={c.id}>
                <span className="comment-username">{c.username}</span>
                <span className="comment-date">{moment(c.date).fromNow()}</span>
                <p>{c.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SinglePicture;
